import { Injectable } from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import {environment} from "../../environments/environment";
import {Router} from "@angular/router";

@Injectable()
export class AuthenticationService {
    public token: string;

    loginUrl = environment.instantPaiementApi + "login";

    constructor(private http: Http,
                private router: Router) {
        // set token if saved in local storage
        this.refreshToken();

        console.log("construction auhent ==> jeton = " + this.token);
    }

    getToken() : string {
        this.refreshToken();
        return this.token;
    }

    refreshToken() : void {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if(currentUser && currentUser.token)
            this.token = currentUser.token;
    }

    login(username: string, password: string): Promise<boolean> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        console.log("login ==> " + JSON.stringify({ 'login': username, 'password': password }));
        return this.http.post(this.loginUrl, JSON.stringify({ 'login': username, 'password': password }), options)
            .toPromise()
            .then(response => {
                // login successful if there's a jwt token in the response
                let token = response.json() && response.json().token;
                if (token) {
                    // set token property
                    this.token = token;

                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({ username: username, token: token, date: new Date() }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            })
            .then(undefined, (error) => { return error; });
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('currentUser');
        this.router.navigate(["/admin-login"]);
    }
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/authentication.service.ts